import styled from 'styled-components';

const FooterContent = styled.div`
  padding-top: 40px;
`;

export default FooterContent;
